import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { blue, green, grey, orange, purple, red } from './colors';
import { buildPaletteFromMetadata, type PaletteTokenMetadata, type Token } from './panw-palette/token-metadata';

const syntaxHighlightingTokens = [
  { propertyPath: 'strong', tokenName: '--syntax-tags-strong' },
  { propertyPath: 'bool', tokenName: '--syntax-tags-bool' },
  { propertyPath: 'string', tokenName: '--syntax-tags-string' },
  { propertyPath: 'name_green', tokenName: '--syntax-tags-name-green' },
  { propertyPath: 'name_red', tokenName: '--syntax-tags-name-red' },
  { propertyPath: 'keyword', tokenName: '--syntax-tags-keyword' },
  { propertyPath: 'comment', tokenName: '--syntax-tags-comment' },
] satisfies Token[];

export const syntaxHighlightingTokenMetadata: PaletteTokenMetadata = {
  componentName: 'syntax-highlighting',
  tokens: syntaxHighlightingTokens,
};

export const syntaxHighlighting = (
  mode: PaletteMode,
  opts: GetThemeOptions
): NonNullable<PaletteOptions['syntaxHighlighting']> => {
  if (opts.panwRebrandStubYear) {
    const semanticTokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata<NonNullable<PaletteOptions['syntaxHighlighting']>>(
      syntaxHighlightingTokens,
      semanticTokens,
      xcorTokens
    );
  }

  // none of this is used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
  return mode === 'light'
    ? {
        strong: blue[600],
        bool: orange[600],
        string: green[700],
        name_green: green[700],
        name_red: red[600],
        keyword: purple[600],
        comment: grey[600],
      }
    : {
        strong: blue[300],
        bool: orange[300],
        string: green[300],
        name_green: green[300],
        name_red: red[300],
        keyword: purple[300],
        comment: grey[300],
      };
};
